$(function () {
    // Get a handle
    var navItems = $('.news-list-nav > .item');
    var newsItems = $(navItems).closest('.ze-news-list').find('.ze-news-item');
    var btns = $('.ze-news-list__in').find('.show-more-btn');

    navItems.click(function () {
        var clickedCat = $(this).data('cat');
        var id = $(this).data('resp-id');

        var url = new URL(window.location);
        url.searchParams.set('sus', id);
        window.history.pushState({}, '', url);

        navItems.removeClass('active');
        $(this).addClass('active');

        newsItems.addClass('hidden');
        var filteredItems = new Array();
        newsItems.each(function () {
            if ($(this).data('cat') == clickedCat) {
                filteredItems.push(this);
            }
        });

        $(filteredItems).each(function () {
            $(this).removeClass('hidden');
        });

        if (clickedCat == 'all') {
            newsItems.removeClass('hidden');

            url.searchParams.delete('sus');
            window.history.pushState({}, '', url);
        }

        btns.addClass('hidden');
        btns.each(function () {
            if ($(this).data('cat') == clickedCat) $(this).removeClass('hidden');
        });
    });


    $(document).ready(function () {
        if ($('#stockJsonData').length) {
            StockPriceTicker();
            setInterval(function () { StockPriceTicker(); }, 1200000);
        }
    });
});

function StockPriceTicker() {
    var stockJson = $('#stockJsonData').val();
    if (stockJson == null && stockJson == '') return;

    var json = JSON.parse(stockJson);
    //console.log(json, json.GetStockQuoteListResult[0], json[0]);
    var result = json.GetStockQuoteListResult[0];

    // get a handle
    var stockPrice = $('.stock-price');
    var stockChange = $('.stock-change');
    var delay = $('.stocks-details > .price-delay');
    var lastUpdate = $('.stocks-details > .last-update');

    stockPrice[0].innerHTML = `<span>$</span><span>${result.TradePrice}</span>`;

    if (result.Change < 0) {
        stockChange[0].innerHTML =
            `<span class="text-error-cus">${result.Change} | </span><span class="text-error-cus">( ${(result.PercChange).toFixed(2)}% )</span>`;
    } else {
        stockChange[0].innerHTML =
            `<span class="text-success-cus">+${result.Change} | </span><span class="text-success-cus">( ${(result.PercChange).toFixed(2)}% )</span>`;
    }

    lastUpdate[0].innerHTML = `<span>Pricing delayed by 20 minutes</span><br/><span>Last update</span> <span>${result.TradeDate}</span>`
}

function roundToNearest15(date = new Date()) {
    const minutes = 5;
    const ms = 1000 * 60 * minutes;

    return moment(Math.floor(date.getTime() / ms) * ms);
}